module.exports = __webpack_public_path__ + "static/media/appcoins.fe6e0581.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/appcoins.png
// module id = 1854
// module chunks = 146